import React from 'react';
import { connect } from 'react-redux';

import {
  workflowSetStageConditionRule,
  workflowToggleSkipStage,
} from '~/actions/workflow';
import { Box } from '~/eds/src/components/Box/Box';
import { Card } from '~/eds/src/components/Card/Card';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { StatusText } from '~/eds/src/components/StatusText/StatusText';
import { TicketStageType } from '~/enums/TicketStageType';
import { useIntl } from 'react-intl';

import SkipStageAccordion from '../../shared/SkipStageAccordion';

const Edit = ({
  // connected
  conditionRule,
  disabled,
  isSkipped,
  isWSSDesignated,
  workflowSetStageConditionRule,
  workflowToggleSkipStage,
}) => {
  const intl = useIntl();

  const handleUpdateStageConditionRule = (updatedConditionRule) => {
    workflowSetStageConditionRule({
      conditionRule: updatedConditionRule,
      stage: TicketStageType.Edit,
    });
  };

  const handleToggleEnableStage = (updatedIsSkipped) => {
    workflowToggleSkipStage({
      isSkipped: updatedIsSkipped,
      stage: TicketStageType.Edit,
    });
  };

  return (
    <>
      <Layout direction={'column'} spacing={3}>
        {isWSSDesignated && (
          <Card mode={'bordered'} size={'s'}>
            <Layout flex="auto" spacing={3}>
              <StatusText
                variant="xs-dense"
                icon={'info'}
                text={intl.formatMessage({
                  id: 'Edit.strategicSourcingMessage',
                  defaultMessage:
                    'Strategic Sourcing workflows must include the Edit stage.',
                  description:
                    'Info message about Strategic Sourcing workflow requirements',
                })}
                status={'info'}
                iconSpacing={'s'}
              ></StatusText>
            </Layout>
          </Card>
        )}
        <Box disabled={isWSSDesignated || disabled}>
          <SkipStageAccordion
            conditionRule={conditionRule}
            isSkipped={isSkipped}
            onChange={handleUpdateStageConditionRule}
            onToggle={handleToggleEnableStage}
          />
        </Box>
      </Layout>
    </>
  );
};

const mapStateToProps = ({ builder, workflow }) => {
  const stage = workflow.stages[TicketStageType.Edit];
  return {
    disabled: !builder.shouldEnableAllComponents,
    conditionRule: stage.conditionRule,
    isSkipped: !stage.isEnabled,
    isWSSDesignated: workflow.wssDesignated,
  };
};

export default connect(mapStateToProps, {
  workflowSetStageConditionRule,
  workflowToggleSkipStage,
})(Edit);
